import Axios from 'axios'
import Vue from "vue"
// import Vant from 'vant';
// import 'vant/lib/index.css';
// import { Toast } from "vant";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

// Vue.use(Vant);
// Axios.defaults.baseURL = '/api'
// Axios.defaults.baseURL = 'http://apiyha.yzzh.tech/jeecg-boot/'
Axios.defaults.baseURL = window.network["domianURL"] // 在index配置
Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
Axios.interceptors.request.use(
    config => {
        console.log(config);
        return config
    }

)
Axios.interceptors.response.use(

    response => {
        // Toast({
        //     message: response,
        //     duration: 2000,
        // });
        // this.$message.info('This is a normal message');
        if (response && response.data && 200 != response.data.code) {
            console.log(response.data.message);
            // this.$message.info(response.data.message);

        }
        return response;
    },
    error => {
        if (error.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
            Toast("超时提示 当前人数过多 请稍后");
            return Promise.reject(error); // reject这个错误信息
        }
        return Promise.reject(error);
    });
export default Axios


// WEBPACK FOOTER //
// ./src/Axios.js